module.exports = __webpack_public_path__ + "static/img/mgg.fb7b43d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/mgg.png
// module id = nR8k
// module chunks = 1